import { formatDate } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { DATE_FORMATS } from '../models/date-adapter';

@Pipe({
    name: 'formatDate',
})
export class FormatDatePipe implements PipeTransform {
    /**
     * Formats the given date value to a formatted date based on the users language settings.
     *
     * @param value the date value to transform to formatted date, either a string type or a js date type.
     * @param type the date type to format to, date or datetime.
     * @param omitHostTimezone whether to adding a timezone offset to the date based on the users host or not.
     * @param includeSeconds whether datetime output should include seconds.
     * @returns the date as a formatted date.
     */
    transform(value: string | Date, type: 'date' | 'datetime' = 'date', omitHostTimezone: boolean = true, includeSeconds: boolean = false): string {
        let date;

        if (typeof value === 'string') {
            date = new Date(value);
        }

        if (value instanceof Date) {
            date = value;
        }

        if (!!date && date.toString() !== 'Invalid Date') {
            const dateformat = type === 'datetime' ? DATE_FORMATS.display.dateInput.format + (includeSeconds ? ', HH:mm:ss' : ', HH:mm') : DATE_FORMATS.display.dateInput.format;
            const language = DATE_FORMATS.display.dateInput.language || navigator.language || navigator.languages[0] || 'nb-NO';

            return formatDate(date, dateformat, language, omitHostTimezone ? '+0000' : undefined);
        }

        return '';
    }
}
